<template>
    <v-dialog v-model="dialog" persistent fullscreen
    >
        <v-layout align-center justify-center row fill-height
                  :style="{ backgroundImage: 'url(' + require('@/assets/img/login-bkg.jpg') + ')' }"
                  style="background-size: cover">
            <v-card style="min-width:800px; opacity: 80%">
                <v-card-title class="accent white--text subheading">
                    <img v-if="brandName=='JEC'" :src="require('@/assets/img/logojec.jpg')" height="50"/>
                    <img v-if="brandName=='Carnot Innovations'" :src="require('@/assets/img/carnotLogo.png')" height="40"/>
                    <span v-if="brandName!=='JEC'">{{brandName}}</span>
                </v-card-title>
                <v-card-text>
                    <v-alert :value="true" type="error">
                        {{ 'Page Not Found'|translate }}
                    </v-alert>
                </v-card-text>
                <v-card-actions class="justify-center pb-8">
                    <v-spacer></v-spacer>
                    <v-btn color="#505050" large @click="redirectHome">{{'Back to Home'|translate}}</v-btn>
                </v-card-actions>
            </v-card>
        </v-layout>
    </v-dialog>
</template>

<script>
export default {
    name: 'NotFound',
    props: {},
    data() {
        return {
            dialog: true,
            loading: true,

            config: [],
        }
    },
    watch: {},
    computed: {
        brandName() {
            if (localStorage.getItem('brandingOverride') == '1') {
                return "Carnot Innovations"
            }
            return process.env.VUE_APP_BRAND_NAME ? process.env.VUE_APP_BRAND_NAME : "Carnot Innovations"
        },
    },
    methods: {
        redirectHome() {
            window.location.href="/"
        },

    }
}
</script>

<style scoped>

</style>
